import { useEffect, useState } from "react";
import { getMobileOperatingSystem } from "../utils/get_mobile_os";
import { androidAppURL, iosAppURL } from "../config/config";

const PlayerTips = () => {
  const tips = [
    "Did you know? With the R24 App you can both listen to this podcast and read it!",
    "Did you know? With the R24 App you can add this podcast to your Playlist - and listen to it while walking or driving.",
    "Did you know? With the R24 App you can read the Tehillim chapters with a word-for-word translation while listening to the Hebrew recitation. It's a great way to learn Hebrew!",
    "Did you know? Every day you can find your fresh “Chitat” podcasts - on Torah, Tehillim and Tania - in the R24app.",
  ];

  let [index, setIndex] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      if (index === tips.length - 1) {
        setIndex(0);
      } else {
        setIndex(index + 1);
      }
    }, [15000]);
  }, [index]);

  return (
    <div className="flex items-center gap-2">
      <div className="w-6 h-6">
        <svg fill="#fcba03" xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="m22 10-.625-1.375L20 8l1.375-.625L22 6l.625 1.375L24 8l-1.375.625Zm-3-4-.95-2.05L16 3l2.05-.95L19 0l.95 2.05L22 3l-2.05.95ZM9 22q-.825 0-1.412-.587Q7 20.825 7 20h4q0 .825-.587 1.413Q9.825 22 9 22Zm-4-3v-2h8v2Zm.25-3q-1.725-1.025-2.737-2.75Q1.5 11.525 1.5 9.5q0-3.125 2.188-5.312Q5.875 2 9 2q3.125 0 5.312 2.188Q16.5 6.375 16.5 9.5q0 2.025-1.012 3.75-1.013 1.725-2.738 2.75Z"/></svg>
      </div>
      <p className="text-xs flex-grow">{tips[index]}</p>
      <div>
        <a
        className="rounded-lg bg-transparent text-xs text-blue-500 hover:text-white hover:bg-blue-500 transition border border-blue-500 py-2 px-4"
          href={
            getMobileOperatingSystem() === "android" ||
            getMobileOperatingSystem() === "windows"
              ? androidAppURL
              : getMobileOperatingSystem() === "ios"
              ? iosAppURL
              : androidAppURL
          }
        >
          DOWNLOAD
        </a>
      </div>
    </div>
  );
};

export default PlayerTips;
